import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  flex-direction: column;
  display: flex;

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
    font-family: DM Sans;
  }

  hr {
    margin: 1.5rem 0rem;
    height: 1px;
    background-color: rgba(82, 82, 82, 0.64);
    border: none;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;
  height: 100%;

  input {
    width: 22.5rem;
  }

  textarea {
    width: 100%;
    height: 96px;
    background: var(--black-100);
    border-radius: 4px;
    margin-top: 12px;
    padding: 1rem;
    font-family: Inter;
  }

  p {
    color: var(--white);
  }

  select {
    width: 22.5rem;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 1.5rem;

  h3 {
    margin-bottom: 1.5rem;
  }

  &:first-of-type {
    border-right: 1px solid #3d3d3d;
    select,
    input {
      width: 100%;
    }
  }

  .info-input {
    margin-bottom: 1rem;
  }

  > div {
    width: 100%;

    > div,
    > div > input {
      width: 100% !important;
      margin-top: 1rem;
    }
  }
`;

export const AutoCompleteContainer = styled.div``;

export const ServicesContainer = styled.div`
  margin-top: 1rem;

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
    font-family: DM Sans;
  }
`;

export const ServiceList = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  span {
    margin-top: 1rem;
    color: var(--white);
    font-family: Inter;
  }

  > div {
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 5px;
    background: var(--black-400);
    margin-right: 0.5rem;
    margin-top: 0.8rem;
    padding: 0.5rem 0.8rem 0.5rem 0.8rem;

    p {
      font-size: 0.9rem;
    }

    > button {
      background-color: var(--black-300);
      padding: 0rem;
      width: 26px;
      height: 26px;
      border-radius: 100%;
      margin-left: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.4s;

      &:hover {
        background-color: var(--black-100);
      }

      img {
        width: 20px;
        height: 20px;
      }
    }
  }
`;
